import * as yup from 'yup';

const formikSchema = {
  initialValues: {
    username: '',
    password: '',
  },
  validationSchema: yup.object({
    username: yup.string().email().required(),
    password: yup.string().min(5).required(),
  }),
};

export default formikSchema;
